import React from 'react';
import LoginForm from '../components/LoginForm';

const LoginPage = props => (<LoginForm refUrl={props.match.params.refUrl} />);

export default LoginPage;
